import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  ManufacturerModelForm,
  ModelFormDropDownState,
  ManufacturerModelState,
} from "../types";

export const initialManufacturerModelForm: ManufacturerModelForm = {
  manufacturerID: "",
  year: "",
  modelDesc: "",
  chassisWidth: "",
  chassisHeight: "",
  baseBeamType: "",
  maxWidth: "",
  frontExtension: "",
  licenseWeight: "",
  weelDrive: "",
  baseBeamTypeRoof: "",
  chassisWeight: "",
  frontWeelBase: "",
  registrationInstruction: "",
  sideLighting: false,
  sideGuard: false,
  mudguard: false,
  extendableChassis: false,
  notes: "",
};

export const initialFormDropDownState: ModelFormDropDownState = {
  items: [],
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  loading: false,
};

export const initialState: ManufacturerModelState = {
  loading: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  error: null,
  manufacturerFilter: "ALL",
  manufacturerOptions: [],
  masterModelFilter: "ALL",
  masterModelOptions: [],
  yearFilter: "ALL",
  yearFilterOptions: [],
  licensingWeightFilter: "ALL",
  WeightFilterOptions: [],
  isAddModalOpen: false,
  form: initialManufacturerModelForm,
  selectedId: 0,
  modelFormDropDowns: {
    manufacturers: { ...initialFormDropDownState },
    superModels: { ...initialFormDropDownState },
  },
};
